//
// Copyright ArangoDB GmbH, Cologne, Germany
// All rights reserved. See LICENSE.md in the project root for license information.
//

import { createContext } from "react";
import { FileParserArgs } from "../hooks/useFileParser";

export const PapaparseContext = createContext({} as FileParserArgs);
